import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton, Popover } from "@mui/material";
import React, { useState } from "react";

export enum PiPopoverMenuStyle {
  Default = "default",
  Light = "light"
}

interface PiPopoverMenuProps {
  children?: React.ReactNode;
  style?: PiPopoverMenuStyle;
  softIconHover?: boolean;
  modernMenu?: boolean;
}

export default function PiPopoverMenu({
  children,
  style = PiPopoverMenuStyle.Default,
  softIconHover = false,
  modernMenu = false,
}: PiPopoverMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openPopover, setOpenPopover] = useState<boolean>(false);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
    setOpenPopover(true);
  }

  return (
    <div>
      <IconButton
        aria-label="pipopovermenu-icon-button"
        className="w-[30px] h-[30px]"
        onClick={(event) => handleClick(event)}
        sx={
          softIconHover
            ? {
                color: "#919BA7",
                transition: "color 120ms ease",
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#6C99B3",
                },
                "&:focus-visible": {
                  backgroundColor: "transparent",
                  color: "#6C99B3",
                },
              }
            : undefined
        }
      >
        <MoreHorizIcon
          className={style === PiPopoverMenuStyle.Default ?
            "" : "text-interaction-primary-faded"}
          fontSize={style === PiPopoverMenuStyle.Default ?
            "small" : "medium"} />
      </IconButton>

      <Popover
        open={openPopover}
        onClose={() => setOpenPopover(false)}
        anchorEl={anchorEl}
        // Right-aligned to the trigger, so the menu grows leftward into the
        // card it belongs to instead of rightward over whatever is beside it.
        // The trigger sits at the right edge of every row and card that uses
        // this, so left alignment pushed the panel off its own container.
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: modernMenu
            ? {
                // 8px: the card radius the tiles, rows and dialogs already
                // use. 10px read as a softer, separate family, and the menu
                // items inside are 6px — an 8/6 nesting sits right, 10/6 does
                // not.
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
                padding: "6px",
                minWidth: "200px",
                backgroundColor: "var(--pi-surface)",
              }
            : { width: "auto" },
        }}
      >
        <div
          className={
            modernMenu
              ? "w-full flex flex-col"
              : "w-[200px] mt-2 mb-2 mr-4 ml-4"
          }
          onClick={() => setOpenPopover(false)}
        >
          {children}
        </div>
      </Popover>
    </div>
  );
}
